module.exports = __webpack_public_path__ + "img/logo.c381ff92.png";